<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="5">
					类型：
					<el-select v-model="type" @change="changeType" placeholder="请选择" size="mini" style="width:120px;">
						<el-option v-for="item in [
							{label:'全部',value:0},{label:'充值',value:1},{label:'消费',value:2},{label:'退货',value:3},{label:'换货',value:4},{label:'其他',value:5},{label:'充值退款',value:6},
						]" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
					</el-select>
				</el-col>
				<el-col :span="10">
					日期：
					<el-date-picker
						style="width:320px;"
						v-model="timeRange"
						@change="changeTimeRange"
						type="datetimerange"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
						size="mini">
					</el-date-picker>
				</el-col>
				<el-col :span="2" :offset="7">
					<el-button v-if="$buttonAuthority('mendian-refund')" @click="refund" size="mini">清空账户</el-button>
					<!-- <el-button @click="add" size="mini">充值</el-button> -->
				</el-col>
			</el-row>
		</div>
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column label="关联单号" width="200" >
					<template slot-scope="scope">
						<div v-for="(item,index) in scope.row.order_num.split(',')" :key="index" @click="see(item,scope.row)" class="linkText">{{item}}</div>
					</template>
				</el-table-column>
				<el-table-column label="日期">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.create_time,'YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="类型" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.consume_type===1">充值</span>
						<span v-if="scope.row.consume_type===2">消费</span>
						<span v-if="scope.row.consume_type===3">退货</span>
						<span v-if="scope.row.consume_type===4">换货</span>
						<span v-if="scope.row.consume_type===5">其他</span>
						<span v-if="scope.row.consume_type===6">充值退款</span>
					</template>
				</el-table-column>
				<el-table-column label="服务地点" width="200">
					<template slot-scope="scope">
						{{scope.row.service_address}}
					</template>
				</el-table-column>
				<el-table-column label="变化值" width="110">
					<template slot-scope="scope">
						<span v-if="scope.row.type_id===1" style="color:rgb(24, 164, 76)">+{{scope.row.consume.user_yue}}</span>
						<span v-if="scope.row.type_id===2" style="color:#FF182A">-{{scope.row.consume.user_yue}}</span>
					</template>
				</el-table-column>
				<el-table-column label="变动后余额" width="150">
					<template slot-scope="scope">
						{{scope.row.after.user_yue}}
					</template>
				</el-table-column>
				<el-table-column label="备注" width="150">
					<template slot-scope="scope">
						{{scope.row.remark}}
					</template>
				</el-table-column>
				<!-- <el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)">查看</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</div>
		<div v-if="drawerRechargeRefund_state">
			<rechargeRefund @submit="submit_drawerRechargeRefund"></rechargeRefund>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import rechargeRefund from "../drawer/rechargeRefund.vue"
	export default {
		components:{page,rechargeRefund},
		data(){
			return{
				type:0,
				timeRange:'',
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				
				// 退款
				drawerRechargeRefund_state:false,
				
				
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		watch:{
			userInfo(){
				this.page.page=1;
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// add(){
			// 	this.$store.commit('mendian/set_curBusiness','充值')
			// 	this.$store.commit('recharge/set_type','add')
			// },
			// 余额退款
			refund(){
				this.drawerRechargeRefund_state = true;
			},
			submit_drawerRechargeRefund(obj){
				this.drawerRechargeRefund_state = false;
				if(obj.type==='success'){
					this.dialogSettlement_state = true;
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
					this.$message({
						message: '余额退款申请已提交，请等待审核！！',
						type:'success'
					});
					return ;
				}
			},
			// 查看订单
			see(orderId,row){
				if(row.consume_type===1){
					this.$router.push({path:'/rechargeOrder/rechargeOrderSee',query:{id:orderId}})
				}else if(row.consume_type===2){
					this.$router.push({path:'/dingdan/saleOrderSee',query:{id:orderId}})
				}else if(row.consume_type===3){
					this.$router.push({path:'/returnOrder/returnOrderSee',query:{id:orderId}})
				}else if(row.consume_type===4){
					this.$router.push({path:'/returnOrder/returnOrderSee',query:{id:orderId}})
				}else{
					console.log("无法判断订单类型")
				}
			},
			// 改变类型
			changeType(){
				this.page.page=1;
				this.getTableData();
			},
			// 改变时间
			changeTimeRange(){
				this.page.page=1;
				this.getTableData();
			},
			// 分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取列表
			getTableData() {
				let startTime='';
				let endTime='';
				if(this.timeRange&&this.timeRange.length==2){
					startTime=(''+new Date(this.timeRange[0]).getTime()).substr(0,10);
					endTime=(''+new Date(this.timeRange[1]).getTime()).substr(0,10);
				}
				let params = {
					keyword:'', 
					type:'4',
					consume_type:this.type,    // 消费类型 0:全部、1:充值、2:消费、3:退货、4:换货、5:其他
					start_time:startTime,
					end_time:endTime,
					"member_id": this.userInfo._id,
					"page_index": this.page.page,
					"page_size": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post('/api/Member/PropertyRecord', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:52px 0 0;box-sizing: border-box;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:12px 12px 12px;
		box-sizing: border-box;
		position: absolute;
		top:0;
		font-size: 14px;
		color:$fontColor;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
		.linkText{
			color:$mainColor;
		}
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
